<template>
    <div>
        <div class="container mt-5" v-if="errorMsg">
            <div class="alert alert-danger">{{ errorMsg }}</div>
        </div>

        <div class="container mt-5">
            <div class="row">
                <bericht v-for="(item, index) in items" :key="item.id" :index="index" :item="item"></bericht>
            </div>
            <div class="row justify-content-center text-center">
                <div class="col-8">
                    <transition name="fade">
                        <button v-if="hasMore" type="button" class="btn btn-outline-primary my-4" @click="loadMore()">
                            <span v-if="processing"><spinner :color="'#fdccaf'"></spinner></span>
                            <span v-else>Toon meer</span>
                        </button>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Spinner from 'vue-spinner-component/src/Spinner.vue';
import Bericht from "./Bericht";

export default {
    components: {
        Bericht,
        Spinner,
    },
    props: {
        totalAvailable: Number,
        perPage: Number,
    },
    data() {
        return {
            hasMore: false,
            items: [],
            page: 1,
            processing: false,
            errorMsg: null,
        }
    },
    mounted() {
        let timeDiff = Date.now() - this.$session.get('berichten-index-page-time');
        if (timeDiff < (3 * 60 * 1000)) {
            this.showPreviousItems();
        } else {
            this.makeFreshCall();
        }
    },
    methods: {
        makeFreshCall() {
            this.page = 1;

            this.getItems(this.page).catch(() => {
                this.errorMsg = 'Fout bij het ophalen van de items.';
            });
        },
        getActiveFilters() {
            return this.filters.filter(function (filter) {
                return filter.active;
            });
        },
        loadMore() {
            this.getItems(++this.page).catch(() => {
                this.page--;
                this.errorMsg = 'Fout bij het ophalen van de items.';
            });
        },
        getItems(page) {
            this.errorMsg = null;

            return this.request(page).then(response => {
                if (this.page === 1) {
                    this.items = response.data.list;
                } else {
                    this.appendItems(response);
                }

                this.hasMore = response.data.hasMore;

                this.setSessionStorage();
            });
        },
        request(page) {
            return this.axios.post('/api/berichten', {
                page: page,
            })
        },
        appendItems(response) {
            let that = this;

            // Append items
            response.data.list.forEach(item => {
                that.items.push(item);
            });
        },
        setSessionStorage() {
            this.$session.set('berichten-index-page', this.page);
            this.$session.set('berichten-index-page-time', Date.now());
        },
        showPreviousItems() {
            let highestPage = this.$session.get('berichten-index-page');

            let requests = [];
            for (let i = 1; i <= highestPage; i++) {
                requests.push(this.request(i))
            }

            this.errorMsg = null;

            this.axios.all(requests).then(this.axios.spread((...responses) => {
                responses.forEach(response => {
                    this.appendItems(response);
                    this.hasMore = response.data.hasMore;
                })
            }));
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/Berichten.vue